import { defineComponent as _defineComponent } from 'vue'
export interface IOverlayProps {
  zIndex?: number;
  bgColor?: string;
}

import { withDefaults } from '../../../adapter-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    zIndex: { default: 9999 },
    bgColor: { default: 'rgba(0, 0, 0, 0.6)' }
  },
  emits: ['clickHandler', 'touchHandler'],
  setup(__props: any, { emit: emits }) {

const props = __props as { zIndex: number, bgColor: string }





function click() {
  emits('clickHandler');
}
function tap() {
  emits('touchHandler');
}

return { __sfc: true,emits, props, click, tap }
}

})